import { string, number, object, array } from '@gogame/schemas';

import {
  NAME,
  INFLUENCER_CHANNEL_URL,
  CATEGORY,
  PRICE,
  PRICE_WITH_FEE,
  AGENCY,
  AGENCIES,
  INFLUENCER,
  SOCIAL_MEDIA_PLATFORM,
  CONCURRENT_VIEWERS,
} from './constants';

const agencySchema = object({
  [PRICE]: string().required('Price is required'),
  [PRICE_WITH_FEE]: string().required('Price with fees is required'),
  [AGENCY]: string().required('Agency is required'),
});

export const InfluencerChannelFormValidationSchema = object({
  [NAME]: string().required('Name is required'),
  [INFLUENCER_CHANNEL_URL]: string().required(
    'Influencer channel URL is required'
  ),
  [SOCIAL_MEDIA_PLATFORM]: number().required(
    'Social media platform is required'
  ),
  [CATEGORY]: string().required('Category is required'),
  [AGENCIES]: array(agencySchema).required('Agencies are required'),
  [INFLUENCER]: string().required('Influencer is required'),
  [CONCURRENT_VIEWERS]: number().integer(
    'Concurrent Viewers must be an integer'
  ),
});
